export enum AppEnvironment {
  DEV = 'dev',
  STAGE = 'stage',
  PRODUCTION = 'production',
}
